<template>
  <div>
    
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>Reasignar Paro</v-card-title>
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-h6">Máquina: {{ editedItem.nombre }}</v-list-item-title>
              <v-list-item-subtitle>Duración: {{ editedItem.duracion }} min</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-2" />

          <v-row>
            <v-col cols="12">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-subtitle>Inicio</v-list-item-subtitle>
                  <v-list-item-title>{{ editedItem.inicio }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="12">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-subtitle>Fin</v-list-item-subtitle>
                  <v-list-item-title>{{ editedItem.fin }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider class="my-2" />

          <v-autocomplete
            v-model="selectedOrden"
            :items="ordenesOptions"
            label="Orden de Trabajo"
            item-text="text"
            item-value="value"
            @change="onOrdenChange"
          />

          <v-autocomplete
            v-model="selectedDetalle"
            :items="detalleOptions"
            label="Detalle"
            item-text="text"
            item-value="value"
            :disabled="!selectedOrden"
            @change="onDetalleChange"
          />

          <v-autocomplete
            v-model="selectedOperacionReal"
            :items="operacionOptions"
            label="Operación Real"
            item-text="text"
            item-value="idOperacionReal"
            :disabled="!selectedDetalle"
          />

          <v-autocomplete
            v-model="paroTipo"
            :items="paroTipos"
            label="Tipo de Paro"
            item-text="nombre"
            item-value="idParoTipo"
            clearable
            :disabled="editedItem.asignado"
            :loading="loadingParoTipos"
            no-data-text="No hay tipos de paro disponibles"
          ></v-autocomplete>

          <!-- Debug: Mostrar datos temporalmente -->
          <div v-if="false" class="mt-2 pa-2" style="background: #f5f5f5; font-size: 10px;">
            <div><strong>paroTipos length:</strong> {{ paroTipos.length }}</div>
            <div><strong>paroTipo selected:</strong> {{ paroTipo }}</div>
            <div><strong>loadingParoTipos:</strong> {{ loadingParoTipos }}</div>
          </div>

        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelForm">Cancelar</v-btn>

          <v-btn color="red darken-1" text @click="save" :loading="loaderChange">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="3">
        <v-autocomplete
          v-model="maquinaSeleccionada"
          :items="tokensMaquinas"
          item-text="maquina"
          item-value="idMaquinaIns"
          label="Máquina"
          @change="onMaquinaChange($event); getParosSn()"
          :loading="loadTokensExtras"
          :disabled="loadTokensExtras"
          clearable
          return-object
        />
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          v-model="tokenSeleccionado"
          :items="tokensDisponibles"
          item-text="nombre"
          item-value="idTokenExtra"
          label="Token"
          :disabled="!tokensDisponibles.length"
          clearable
          return-object
          @change="getParosSn"
        />
      </v-col>

      <v-col cols="3">
        <VueCtkDateTimePicker
          v-model="filtros.inicio"
          label="Fecha Inicio"
          format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm"
          noHeader
          overlay
          buttonNowTranslation="Ahora"
          clearable
          @input="getParosSn()"
        />
      </v-col>

      <v-col cols="3">
        <VueCtkDateTimePicker
          v-model="filtros.fin"
          label="Fecha Fin"
          format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm"
          noHeader
          overlay
          buttonNowTranslation="Ahora"
          clearable
          @input="getParosSn(1)"
        />
      </v-col>

      <v-col cols="12">
        <v-data-table :headers="headers" :items="desserts" :loading="loaderData">
          <template v-slot:item.asignado="{ item }">
            <v-chip v-if="item.asignado" color="green" text-color="white">Asignado</v-chip>
            <v-chip v-else color="red" text-color="white">Sin Asignar</v-chip>
          </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            v-if="!item.asignado"
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';

export default {
  data: () => ({
    maquinaSeleccionada: null,
    tokensDisponibles: [],
    tokenSeleccionado: null,
    filtros: { inicio: null, fin: null, estado: false },
    loaderChange: false,
    loaderData: false,
    dialog: false,
    paroTipo: null,
    paroTipos: [],
    loadingParoTipos: false,

    selectedOrden: null,
    selectedDetalle: null,
    selectedOperacionReal: null,

    ordenesOptions: [],
    detalleOptions: [],
    operacionOptions: [],

    headers: [
      { text: "Máquina", align: "center", value: "nombre" },
      { text: "Token", align: "center", value: "token" },
      { text: "Inicio", value: "inicio", align: "center" },
      { text: "Fin", value: "fin", align: "center" },
      { text: "Duración (min)", value: "duracion", align: "center" },
      { text: "Estatus", value: "asignado", align: "center" },
      { text: "Nota", value: "nota", align: "center" },
      { text: "Acciones", value: "actions", align: "center" },
    ],

    desserts: [],
    editedItem: {},
    odtsOpers: [],
    tokensMaquinas: [],
    loadTokensExtras: false,
  }),

  created() {
    this.initialize();
  },

  mounted() {
  },

  methods: {
    initialize() {
      this.getOdtsOpers();
      this.getParosSn();
      this.getMaquinasInsToken();
      this.getParoTipos();
    },
      cancelForm() {
      this.resetForm();
      this.dialog = false;
    },

    getParosSn() {
      this.loaderData = true;
      axios
        .get("/ParosSinAsignar", {
          params: {
            IdMaquinaIns: this.maquinaSeleccionada?.idMaquinaIns || null,
            IdTokenExtra: this.tokenSeleccionado?.idTokenExtra || null,
            Inicio: this.filtros.inicio,
            Fin: this.filtros.fin,
            Estado: this.filtros.estado ?? false,
          },
        })
        .then((res) => {
          this.desserts = res.data;
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loaderData = false;
        });
    },

getParoTipos() {
  this.loadingParoTipos = true;
  
  axios
    .get("/ParoTipos")
    .then((response) => {
      this.paroTipos = response.data;
    })
    .catch((error) => {
      console.error("Error obteniendo tipos de paro:", error);
    })
    .finally(() => {
      this.loadingParoTipos = false;
    });
},

    getOdtsOpers() {
      axios.get("/TrabajoOrdenes/OtsAll").then((res) => {
        
        if (res.data.length > 0) {
          if (res.data[0].odtd && res.data[0].odtd.length > 0) {
            
          
            if (res.data[0].odtd[0].operacionesAll && res.data[0].odtd[0].operacionesAll.length > 0) {
            }
          }
        }
        
        this.odtsOpers = res.data;
        this.ordenesOptions = this.odtsOpers.map((o) => ({
          text: `${o.ot} ${o.clave}`,
          value: o.idTrabajoOrden,
          detalles: o.odtd,
        }));
        
      }).catch((err) => {
      });
    },

    getMaquinasInsToken() {
      this.loadTokensExtras = true;
      axios.get("/Maquinas/MaquinasInstanciasTokens").then((res) => {
        this.tokensMaquinas = res.data;
        this.loadTokensExtras = false;
      }).catch((err) => {
        this.loadTokensExtras = false;
      });
    },

    onMaquinaChange(maquina) {
      if (maquina) {
        this.tokensDisponibles = maquina.tokensExtras || [];
        this.tokenSeleccionado = this.tokensDisponibles.length === 1 ? this.tokensDisponibles[0] : null;
      } else {
        this.tokensDisponibles = [];
        this.tokenSeleccionado = null;
      }
    },

    onOrdenChange(idOrden) {
      const orden = this.odtsOpers.find((o) => o.idTrabajoOrden === idOrden);
      if (!orden) return;
      this.detalleOptions = orden.odtd.map((d) => ({
        text: d.nombreArticulo,
        value: d.idTrabajoOrdenDetalle,
        operaciones: d.operacionesAll,
      }));
    },

    onDetalleChange(idDetalle) {
      
      this.operacionOptions = [];
      this.selectedOperacionReal = null;

      if (!idDetalle) return;
      axios
        .get(`/ParosSinAsignar/OperacionesPorDetalle/${idDetalle}`)
        .then((response) => {
          
          this.operacionOptions = response.data.map((op) => ({
            text: op.nombreOperacion,  // Mostrará "Operación Real #123"
            idOperacionReal: op.idOperacionReal,
          }));
          
          console.log("📋 operacionOptions:", this.operacionOptions);
        })
        .catch((err) => {
        });
    },

    editItem(item) {
      if (item.asignado) return;
      this.editedItem = { ...item };
      this.dialog = true;
    },

    resetForm() {
  this.editedItem = {};
  this.selectedOrden = null;
  this.selectedDetalle = null;
  this.selectedOperacionReal = null;
  this.paroTipo = null;
  },
  save() {
    this.loaderChange = true;

  const data = [
    {
      IdParoNoAsignado: this.editedItem.idParoNoAsignado,
      IdParoTipo: parseInt(this.paroTipo) || 1,
      IdTrabajoOrden: this.selectedOrden,
      IdTrabajoOrdenDetalle: this.selectedDetalle,
      IdOperacionReal: this.selectedOperacionReal,
      IdArea: this.editedItem.idArea,
      IdMaquinaIns: this.editedItem.idMaquinaIns,
      Inicio: moment(this.editedItem.inicio, "YYYY-MM-DD hh:mm:ss a").format("YYYY-MM-DDTHH:mm:ss"),
      Fin: moment(this.editedItem.fin, "YYYY-MM-DD hh:mm:ss a").format("YYYY-MM-DDTHH:mm:ss"),
      ReporteInicio: moment(this.editedItem.inicio, "YYYY-MM-DD hh:mm:ss a").format("YYYY-MM-DDTHH:mm:ss"),
      ReporteFin: moment(this.editedItem.fin, "YYYY-MM-DD hh:mm:ss a").format("YYYY-MM-DDTHH:mm:ss"),
    },
  ];

  axios
    .post("/ParosSinAsignar/GuardarParosAsignados", data)
    .then((response) => {

      const idx = this.desserts.findIndex(
        d => d.idParoNoAsignado === this.editedItem.idParoNoAsignado
      );
      if (idx !== -1) {
        this.$set(this.desserts[idx], "asignado", true);
      }
      
      this.resetForm();
      this.dialog = false;
    })
    .catch((err) => {
      console.error("❌ Error al guardar:", err);
    })
    .finally(() => {
      this.loaderChange = false;
    });
},
  },
};
</script>